export default {
  setPedidosArray(state, p) {
    state.pedidosArray = p;
  },
  setPedidosRealizandoTpv(state, a) {
    state.pedidosRealizandoTpv = a;
  },
  setPedidosRealizandoTpvPush(state, obj) { //los pedidos realizando en tpv por cierre
    let fI = state.pedidosRealizandoTpv.findIndex(p => p.cierre === obj.cierre)
    console.log(obj);
    console.log(state.pedidosRealizandoTpv)
    if (fI > -1) {
      state.pedidosRealizandoTpv[fI].pedidos = obj.pedidos;
    } else {
      state.pedidosRealizandoTpv.push(obj)
    }
  },
  setPedidosPendienteConfirmacionPago(state, p) {
    state.pedidosPendienteConfirmacionPago = p;
  },
  setPedidosEliminar(state, p) {
    state.pedidosEliminar = p;
  },
  setPedidosRestaurante(state, p) { //p = {id_rest, array_pedidos}
    const found = state.pedidosArray.findIndex((e) => e.id == p.id)
    if (found < 0) {
      state.pedidosArray.push(p)
    } else {
      state.pedidosArray[found].array = p.array;
    }
  },
  setPedidosPartner(state, p) { //p = {id_rest, array_pedidos}
    console.log(p);
    const found = state.pedidosArray.findIndex((e) => e.id == p.id)
    if (found < 0) {
      state.pedidosArray.push(p)
    } else {
      state.pedidosArray[found].array = p.array;
    }
  },
  setDiaComprobando1(state, d) {
    state.diaComprobando1 = d;
  },
  setDiaComprobando2(state, d) {
    state.diaComprobando2 = d;
  },
  setRango(state, r) {
    state.diaComprobando1 = r[0];
    state.diaComprobando2 = r[1];
  }

}
